import { render, staticRenderFns } from "./patientInHospitalList.vue?vue&type=template&id=7686abd6&scoped=true&"
import script from "./patientInHospitalList.vue?vue&type=script&lang=js&"
export * from "./patientInHospitalList.vue?vue&type=script&lang=js&"
import style0 from "./patientInHospitalList.vue?vue&type=style&index=0&id=7686abd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7686abd6",
  null
  
)

export default component.exports